module.exports = __webpack_public_path__ + "static/img/meter_3.8fb555cc.gif";